import { pushBottomTick } from "../components/need-help";

class AnimatedDetails {
  private summary: HTMLElement | null;
  private content: HTMLElement | null;
  private animation: Animation | null = null;
  private isClosing: boolean = false;
  private isExpanding: boolean = false;

  constructor(private details: HTMLDetailsElement) {
    this.details = details;
    this.summary = details.querySelector(".js-animated-details-summary");
    this.content = details.querySelector(".js-animated-details-content");
    this.summary?.addEventListener("click", (event) => this.handleClick(event));
  }

  handleClick(event: Event) {
    event.preventDefault();

    this.details.style.overflow = "hidden";

    if (this.isClosing || !this.details.open) {
      this.open();
    } else if (this.isExpanding || this.details.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;

    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${this.summary?.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.details.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 400,
        easing: "ease-out",
      }
    );

    this.animation.onfinish = () => this.animationFinished(false);
    this.animation.oncancel = () => (this.isClosing = false);
  }

  open() {
    this.details.style.height = `${this.details.offsetHeight}px`;
    this.details.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    if (!this.summary || !this.content) {
      return false;
    }

    this.isExpanding = true;

    const startHeight = `${this.details.offsetHeight}px`;

    const endHeight = `${
      this.summary.offsetHeight + this.content.offsetHeight
    }px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.details.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 400,
        easing: "ease-out",
      }
    );
    this.animation.onfinish = () => this.animationFinished(true);
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  animationFinished(open: boolean) {
    this.details.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.details.style.height = this.details.style.overflow = "";
    pushBottomTick();
  }
}

const initAnimatedDetails = () =>
  document.querySelectorAll(".js-animated-details").forEach((details) => {
    new AnimatedDetails(details as HTMLDetailsElement);
  });

window.addEventListener("htmx:afterSwap", initAnimatedDetails);

initAnimatedDetails();
